module.exports = __webpack_public_path__ + "static/media/soviet_train_120x120.dc65884c.png";